'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectFilter = require('./objectFilter');

var _objectFilter2 = _interopRequireDefault(_objectFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {Object} object - object to run filters on
 * @param {String|String[]} filters - property name or names to include
 */
var pick = function pick(object) {
  for (var _len = arguments.length, filters = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    filters[_key - 1] = arguments[_key];
  }

  return _objectFilter2.default.apply(undefined, [object, true].concat(filters));
};

exports.default = pick;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/utils/underscore/pick.js
// module id = 450
// module chunks = 171